;(function ( $ ) {

    /**
     *  numberInput
     *  adds buttons to increment, decrement a number input
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'numberInput';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.min = null;
            this.max = null;
            // this.initialWidth = $(this.element).width();
            // this.initialHeight = $(this.element).height();
            if ($(this.element).attr('min')) {
                this.min = $(this.element).attr('min');
            }
            if ($(this.element).attr('max')) {
                this.max = $(this.element).attr('max');
            }
            this.$fieldset = $(this.element).parents('fieldset');
            // $(this.element).attr('type', 'text');
            if (!this.$fieldset.find('.number-input-wrapper').length) {
                $(this.element).wrap('<div class="number-input-wrapper" />');
                this.$wrapper = this.$fieldset.find('.number-input-wrapper');
                this.$wrapper.prepend('<a href="#" class="number-decrement bg-color-event-dark"><span class="icon icon-minus"></span></div>');
                this.$wrapper.append('<a href="#" class="number-increment bg-color-event-dark"><span class="icon icon-plus"></span></div>');
                this.$decrement = this.$wrapper.find('.number-decrement');
                this.$increment = this.$wrapper.find('.number-increment');
            }
            // $(this.element).width(this.initialWidth - 160);
            this.registerEvents();
        },
        registerEvents: function() {
            var _this = this;
            this.$increment.on('click', function(e) {
                e.preventDefault();
                _this.val = parseInt($(_this.element).val());
                _this.val++;
                if (_this.max === null || (_this.max !== null && _this.val <= _this.max)) {
                    $(_this.element).val(_this.val);
                    $(window).trigger('number.change');
                    _this.toggleDisabledButtons();
                }
                else {
                    _this.showMaxError();
                }
            });
            this.$decrement.on('click', function(e) {
                e.preventDefault();
                _this.val = parseInt($(_this.element).val());
                _this.val--;
                if (_this.min === null || (_this.min !== null && _this.val >= _this.min)) {
                    $(_this.element).val(_this.val);
                    $(window).trigger('number.change');
                    _this.toggleDisabledButtons();
                }
                else if( _this.min > 0){
                    _this.showMinError();
                }
            });
            $(this.element).on('change, input', function(e) {
                _this.val = $(_this.element).val();
                if ( isNaN( parseInt( _this.val ) ) ) {
                    _this.val = 0;
                }
                _this.val = parseInt(_this.val);
                if (_this.max !== null && _this.val > _this.max) {
                    _this.val = _this.max;
                    _this.showMaxError();
                }
                if (_this.min !== null && _this.val < _this.min) {
                    _this.val = _this.min;
                    if( _this.min > 0){
                        _this.showMinError();
                    }
                }
                $(_this.element).val(_this.val);
                $(window).trigger('number.change');
                _this.toggleDisabledButtons();
            });

            _this.val = parseInt($(_this.element).val());
            _this.toggleDisabledButtons();
        },

        toggleDisabledButtons: function() {
            var _this = this;
            if (_this.max !== null && _this.val >= _this.max) {
                _this.$increment.addClass('disabled');
            }
            else {
                _this.$increment.removeClass('disabled');
            }
            if (_this.max !== null && _this.val <= _this.min) {
                _this.$decrement.addClass('disabled');
            }
            else {
                _this.$decrement.removeClass('disabled');
            }

        },

        showMinError: function() {
            var _this = this;
            if($('.ticket-card-wrapper')){
                var $card = $(_this.element).closest('.ticket-card'),
                    $layer = $card.find('.ticket-minerror');
                $layer.trigger('click');
            }
        },

        showMaxError: function() {
            var _this = this;
            if($('.ticket-card-wrapper')){
                var $card = $(_this.element).closest('.ticket-card');
                $card.addClass('maxerror');
                $('.ticket-maxerror', $card).find('.icon-close').one('click', function(e) {
                    $card.removeClass('maxerror');
                });
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
